import { Controller } from "@hotwired/stimulus"

// Periodically re-requests the current page via Turbo while a workflow is still being analyzed.
// The server only renders this controller while the workflow is in a non-terminal pre-review state,
// so once it reaches awaiting_review the refreshed page drops the controller and polling stops.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.timer = setInterval(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }
}
